'use strict';
module.exports = require('./compile/runtime');